import React from 'react';

const Checkbox = (props) => {
  return (
    <input
      className={props.className}
      type="checkbox"
      checked={props.checked}
      onClick={(event)=>{
        props.handleCheckBox(props.id.split('-')[0], props.id.split('-')[2],event.currentTarget.checked);
      }}
    />
  )
}

export default Checkbox;